<template>
    <vue-tags-input
        v-model="current"
        :tags="populate"
        @tags-changed="emit"
        :autocomplete-items="autocomplete"
        placeholder="název štítku"
        />
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
export default {
    components: {
        VueTagsInput
    },

    props: {
        resource: {
            type: Object,
            required: true,
        },
        allTags: {
            type: Array,
            required: true,
        }
    },

    computed: {
        autocomplete() {
            return this.allTags.filter(tag => {
                return tag.text.toLowerCase().indexOf(this.current.toLowerCase()) !== -1;
            });
        },
        populate() {
            return this.resource
                .tagNames
                .map(tagName => ({ text: tagName }));
        },
    },

    data: () => ({
        current: '', // currently typed tag
    }),

    methods: {
        emit(newTags) {
            this.$emit('input', newTags.map(tag => tag.text));
        }
    }
}
</script>
